import React from 'react';

const ServiceArea = () => {
  return (
    <section className="service-area-section">
      <div className="service-area-inner">
        <div className="service-area-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z" />
          </svg>
        </div>

        <h2 className="service-area-title">Service Area</h2>

        <p className="service-area-copy">
          We proudly provide services in <strong>Barrie</strong> and the surrounding region
        </p>

        <a
          href="https://share.google/PAEvXkrYqtTPxzZyQ"
          target="_blank"
          rel="noopener noreferrer"
          className="service-area-button"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z" />
          </svg>
          See Our Google Profile
        </a>
      </div>
    </section>
  );
};

export default ServiceArea;
